import { createApp, App as VueApp } from 'vue'
import GaragePartsCustomizedApp from './GaragePartsCustomized/App.vue'
import GaragePartsSummeryApp from './GaragePartsSummery/App.vue'
import "./../scss/app.scss"

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import './garage-part-pickers';
// register Swiper custom elements
register();

function mountApps() {
	const garagePartsCustomizedApps = document.querySelectorAll<HTMLElement>('.gc-garage-parts-customized--app')

	for (var i = 0; i < garagePartsCustomizedApps.length; i++) {
		const garagePartsCustomizedApp = garagePartsCustomizedApps[i]

		const rootProps = garagePartsCustomizedApp?.dataset?.props ? JSON.parse(garagePartsCustomizedApp.dataset.props) : {}

		let vueApp = createApp(GaragePartsCustomizedApp, {...rootProps})
		vueApp.mount(garagePartsCustomizedApp)
	}

	const garagePartsSummeryApps = document.querySelectorAll<HTMLElement>('.gc-garage-parts-summery--app')

	for (var i = 0; i < garagePartsSummeryApps.length; i++) {
		const garagePartsSummeryApp = garagePartsSummeryApps[i]

		const rootProps = garagePartsSummeryApp?.dataset?.props ? JSON.parse(garagePartsSummeryApp.dataset.props) : {}

		let vueApp = createApp(GaragePartsSummeryApp, {...rootProps})
		vueApp.mount(garagePartsSummeryApp)
	}
}

window.addEventListener('DOMContentLoaded', function() {
	jQuery(document).on('gform_page_loaded', function(event, form_id: string, current_page: number){
		mountApps()
	});

	mountApps()
})
